const modernBrowser = (
  'fetch' in window &&
  'assign' in Object &&
  'entries' in Object &&
  'forEach' in NodeList.prototype
);

if (!modernBrowser) {
  const scriptElement = document.createElement('script');
  scriptElement.async = false;
  scriptElement.src = '/js/pack/polyfills.js';
  document.head.appendChild(scriptElement);
}
